import endpoint from "../../config/endpoints";

export const EnquiryActionJson = {
    showSaveNextBtn: true,
    formPath: "/enquiry-action-form",
    apiBaseURL: endpoint.enquiryAction,
    changeExcel: endpoint.exportData,
    screenTitle: "Enquiry Action",
    showAddButton: true,
    showPdfDownload: false,
    pdfFileName: "Enquiry Action",
    showExcelDownload: true,
    excelFileName: "Enquiry Action",
    isActiveURL: endpoint.enquiryAction + "/update-is-active",
    noteValue: 'Enquiry Action',
    tableColumnsToFilter: [
        {
            columnDisplayName: "Enquiry Action Name",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Enquiry Action Name",
            controlType: "textfield",
            placeHolder: "Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "name",
            isMandatory: true,
            uniqueValidation: true,
        },
    ],
};